import { render, staticRenderFns } from "./DirectPaymentSettings.vue?vue&type=template&id=46db4eec&"
import script from "./DirectPaymentSettings.vue?vue&type=script&lang=js&"
export * from "./DirectPaymentSettings.vue?vue&type=script&lang=js&"
import style0 from "./DirectPaymentSettings.vue?vue&type=style&index=0&id=46db4eec&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46db4eec')) {
      api.createRecord('46db4eec', component.options)
    } else {
      api.reload('46db4eec', component.options)
    }
    module.hot.accept("./DirectPaymentSettings.vue?vue&type=template&id=46db4eec&", function () {
      api.rerender('46db4eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/SettingsList/DirectPaymentSettings.vue"
export default component.exports